import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

import { useCartIsOpen } from '@/app/cart/useCartIsOpen';

import CartSheet from '@/app/cart/CartSheet';
import Mark from './Mark';

const HeaderWithBack = ({ to, title }) => {
  const { openCart } = useCartIsOpen();

  return (
    <>
      <div className="fixed top-0 left-0 right-0 backdrop-blur-sm border-b py-4 pl-2 flex items-center justify-between z-50">
        {to && (
          <Link to={to}>
            <div className="flex items-center gap-1">
              <ChevronLeft size={30} />
              <span className="text-lg font-bold">{title}</span>
            </div>
          </Link>
        )}
        <Mark onClick={() => openCart()} className={to ? '' : 'ml-auto'} />
        <CartSheet />
      </div>
      <div className="h-[64px]"></div>
    </>
  );
};

export default HeaderWithBack;
